import React from 'react';

import * as styles from './style';
import {
  createSliderWithTooltip,
  type RangeProps,
  Range as RcRange,
} from 'rc-slider';

import 'rc-slider/assets/index.css';

export const RangeWithToolTip = createSliderWithTooltip(RcRange);

interface IState {
  leftValue: number;
  rightValue: number;
}

interface IProps extends RangeProps {
  leftLimit: number;
  rightLimit: number;
  leftValue: number;
  rightValue: number;
  step: number;
  minInterval: number;
  handleChange?: (leftValue: number, rightValue: number) => void;
  handleAfterChange?: (leftValue: number, rightValue: number) => void;
  handleFormat: (value: number) => string;
}

export class RangeSlider extends React.Component<IProps, IState> {
  private ref: HTMLDivElement | null = null;

  constructor(props: IProps) {
    super(props);

    // NOTE: may need to implement getDerivedStateFromProps in the future, to update the component based on parent props also
    this.state = {
      leftValue: props.leftValue,
      rightValue: props.rightValue,
    };
  }

  public componentDidUpdate(prevProps: IProps) {
    let leftValue: number | undefined;
    let rightValue: number | undefined;

    if (prevProps.rightValue !== this.props.rightValue) {
      rightValue = this.props.rightValue;
    }

    if (prevProps.leftValue !== this.props.leftValue) {
      leftValue = this.props.leftValue;
    }

    if (leftValue || rightValue) {
      this.setState({
        leftValue: leftValue || this.state.leftValue,
        rightValue: rightValue || this.state.rightValue,
      });
    }
  }

  public getRef = (): HTMLDivElement => {
    return this.ref!;
  };

  public setRef = (ref: HTMLDivElement) => {
    if (!this.ref) {
      this.ref = ref;
      this.forceUpdate();
    }
  };

  private handleLocalChange = (value: number[]) => {
    this.setState({
      leftValue: value[0],
      rightValue: value[1],
    });

    if (this.props.handleChange) {
      this.props.handleChange(value[0], value[1]);
    }
  };

  private handleAfterChange = (value: number[]) => {
    if (this.props.handleAfterChange) {
      this.props.handleAfterChange(value[0], value[1]);
    }
  };

  public render() {
    return (
      <div ref={this.setRef} className={styles.container}>
        {this.ref && (
          <RangeWithToolTip
            className={styles.sliderStyle}
            value={[this.state.leftValue, this.state.rightValue]}
            step={this.props.step}
            min={this.props.leftLimit}
            max={this.props.rightLimit}
            tipProps={{
              visible: true,
              overlayClassName: styles.tipStyle,
              placement: 'bottom',
              getTooltipContainer: this.getRef,
            }}
            tipFormatter={this.props.handleFormat}
            allowCross={false}
            pushable={this.props.minInterval}
            onChange={this.handleLocalChange}
            onAfterChange={this.handleAfterChange}
          />
        )}
      </div>
    );
  }
}
